export const PageTitle: React.FC<{ title: string }> = ({ title }) => {
  return (
    <div className="mb-8 text-2xl-semi w-[100%] max-w-[1500px]">
      <p className="text-h2 pb-2">{title}</p>
      <div className="w-full h-[2px] bg-bh-black"></div>
    </div>
  )
}
